import { render, staticRenderFns } from "./ImpressaoFormularioCasamento.vue?vue&type=template&id=5a159328&"
import script from "./ImpressaoFormularioCasamento.vue?vue&type=script&lang=js&"
export * from "./ImpressaoFormularioCasamento.vue?vue&type=script&lang=js&"
import style0 from "./ImpressaoFormularioCasamento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports